var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card pt-sm-10 pb-sm-15 pa-0"},[_c('div',{staticClass:"card__title px-4 px-sm-12 mb-sm-10 mb-10"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card__body px-sm-15 px-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }